import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { AccountCircle, ExitToApp, ArrowDropDown}  from '@mui/icons-material';

import { useGetUserPurchasePlan } from 'api';
import { doSetLogout, selectDisplayName, selectIsRegistered } from 'features/logon/logonSlice';
import navigationPaths from 'engine/navigationPaths';
import { LogOut } from 'engine/baseApiClient';
import { Button } from 'components/ui';

import * as Styled from './accountMenu.styles';
import { resources } from 'oems/resources';
import { useTheme } from '@emotion/react';
import { useMediaQuery } from '@mui/material';
import { OEM } from 'utility/OEMProvider';
import get from 'lodash/get';
import { useMemo } from 'react';
import { useGetUserPurchasePlanLimitStates } from 'api/endpoints/getUserPurchasePlanLimitStates';
//import { PlanInfo } from 'oems/snaptax/src/components/PlanInfo/PlanInfo';
import { lazy } from 'react';
import { Suspense } from 'react';

export default function AccountMenu() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [anchorEl, setAnchorEl] = React.useState(null);

  const isRegistered = useSelector(selectIsRegistered);
  const displayName = useSelector(selectDisplayName);

  const theme = useTheme();
  const isGreaterThanMD = useMediaQuery(theme.breakpoints.up('md'));

  const { data: userPlanData } = useGetUserPurchasePlan();
  const { data: userPurchasePlanLimitStatesData } = useGetUserPurchasePlanLimitStates();

  const handleLogout = async () => {
    setAnchorEl(null);
    await LogOut();
    dispatch(doSetLogout());
    navigate(navigationPaths().LogIn);
  };

  const documentLimit = useMemo(() => {
    return get(userPlanData, 'purchasePlan.items', []).find((item) => item.name === 'DocumentLimit');
  }, [userPlanData]);

  const documentLimitExceeded = useMemo(() => {
    return get(userPurchasePlanLimitStatesData, 'documentLimitExceeded', false);
  }, [userPurchasePlanLimitStatesData]);
 
  const PlanInfo = lazy(() => import(`oems/`+process.env.REACT_APP_OEM_NAME+`/src/components/PlanInfo/PlanInfo`));

  return (
    <Styled.Wrapper>
      <Styled.Button onClick={(event) => setAnchorEl(event.currentTarget)}>
        <AccountCircle />
        {isGreaterThanMD && (
          <React.Fragment>
            {displayName || 'Moje konto'}
            <ArrowDropDown />
          </React.Fragment>
        )}
      </Styled.Button>

      {!!anchorEl && (
        <Styled.Popover
          open
          onClose={() => setAnchorEl(null)}
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          <Styled.DropdownContent>
            {isRegistered ? (
              <>
              <Suspense fallback={<div>Loading...</div>}>
                <PlanInfo 
                  documentLimitExceeded={documentLimitExceeded}
                  setAnchorEl={setAnchorEl}
                  documentLimit ={documentLimit}
                  userPlanData={userPlanData}
                />
              </Suspense>

                <Styled.Menu>
                  <Styled.MenuButton
                    onClick={() => {
                      setAnchorEl(null);
                      navigate(navigationPaths().UserProfile);
                    }}
                  >
                    <AccountCircle /> Mój profil
                  </Styled.MenuButton>
                  <Styled.MenuButton onClick={handleLogout}>
                    <resources.LogoutIcon /> Wyloguj
                  </Styled.MenuButton>
                </Styled.Menu>
              </>
            ) : (
              <Styled.RegisterBox>
                <div className="title">Witaj w {OEM().ProductName}</div>

                <div className="message">Nie masz konta? Zarejestruj się, aby uzyskać dostęp do pełnej oferty!</div>

                <Button
                  className="registerButton"
                  onClick={() => {
                    setAnchorEl(null);
                    navigate(navigationPaths().Register);
                  }}
                >
                  Zarejestruj się
                </Button>

                <div className="separator" />

                <Styled.MenuButton
                  className="login"
                  onClick={() => {
                    setAnchorEl(null);
                    navigate(navigationPaths().LogIn);
                  }}
                >
                  <ExitToApp /> Zaloguj się
                </Styled.MenuButton>
              </Styled.RegisterBox>
            )}
          </Styled.DropdownContent>
        </Styled.Popover>
      )}
    </Styled.Wrapper>
  );
}
